import { Route, RouteProps, Redirect } from "react-router";
export const AdminBMRoute = ({ component: Component, layout: Layout, path: Path, ...rest }) => {

    let result = JSON.parse(localStorage.getItem("user"));
    console.log("ressss", result)
    return <Route
        {...rest}
        render={props =>
            result.isAdmin || result.userTypeId == 5 ? (
                <Layout>
                    <Component {...props} />
                </Layout>
            ) :
                (
                    <Redirect to={{
                        pathname: "/",
                    }} />
                )
        }
    />
}